import React from "react";
import AppText from "../other/AppText";
import { AppIconButton } from "../buttons/AppIconButton";
import { Home, List } from "@/assets/Icons";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";

interface IUsedProductBanner {
  bg: string;
  heading: string;
  subheading: string;
  ctaLabel: string;
  ctaLink: string;
  ctaTheme: "primary" | "secondary" | "ghost" | undefined;
  heroIcon: string;
  textColor: string;
}

const UsedProductBanner = ({
  bg,
  heading,
  subheading,
  ctaLabel,
  ctaLink,
  ctaTheme,
  heroIcon,
  textColor,
}: IUsedProductBanner) => {
  return (
    <div className={cn("lg:flex-row flex flex-col lg:items-center px-10 py-8 justify-between", bg)}>
      <div className="lg:flex-row lg:items-center lg:mb-0 flex flex-col gap-6 mb-6">
        <div className="h-[28px] w-[28px] shrink-0 bg-mellow rounded-full flex justify-center items-center">
          {heroIcon === "home" ? <Home /> : <List />}
        </div>

        <div className="mr-0 lg:mr-[104px] flex flex-col gap-2">
          <AppText type={"HEADLINE_SMALL"} as="h2" className={cn(textColor)}>
            {heading}
          </AppText>

          <AppText type={"BODY_MEDIUM"} className={cn(textColor)}>
            {subheading}
          </AppText>
        </div>
      </div>

      <AppIconButton
        link={ctaLink}
        iconOnRightSide
        icon={<ChevronRight size={20} aria-label="chevron right icon" />}
        intent={ctaTheme}
        bg="dark"
        label={ctaLabel}
        className="lg:ml-auto ml-0"
      />
    </div>
  );
};

export default UsedProductBanner;
